'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React from 'react';
import {List} from '../../../components/lists/List';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {UserChannelItem} from '../UserChannelItem';


export function UserChannelListView(props) {
  return (
    <List
      className={classNames("UserChannelList", props.className)}
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={props.transitionGroupClass}
    >
      {props.list ? props.list.map(model => (
        <UserChannelItem
          key={getId(model)}
          className={props.itemClassName}
          model={model}
          userId={props.userId}
          chatId={getId(model)}
          collection={getCollection(model.target)}
          tagName={get(model, 'metadata.tagName', '')}
          name={model.name}
          latestMessage={renderMessage(model.latestComment)}
          latestReceived={get(model, 'latestComment.date', null)}
          parentName={get(model, 'metadata.parentName', null)}

          onAccessError={props.onAccessError}
          onClick={props.onShowChat}
          onContextMenu={props.onItemContextMenu}

          init={props.init}
        />
      )) : null}
    </List>
  );
}

function renderMessage(latestComment) {
  if (!latestComment) {
    return null;
  } else {
    return (latestComment.author ? latestComment.author + ': ' : '') + latestComment.message;
  }
}

UserChannelListView.propTypes = {
  className: T.string,

  init: T.bool,
};

UserChannelListView.defaultProps = {
  init: true,
};



// WEBPACK FOOTER //
// ./src/js/comments/components/UserChannelList/UserChannelListView.js